/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FileboxIcon = createIcon("FileboxIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.75v9a3 3 0 01-3 3H5.25a3 3 0 01-3-3v-9m19.5-7.5H2.25a1.5 1.5 0 00-1.5 1.5v3h22.5v-3a1.5 1.5 0 00-1.5-1.5Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 110-3h3a1.5 1.5 0 011.5 1.5Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "i18nKey": "svg.FileboxIcon",
  "replaceColor": true
});